import NamedLink, { NamedLinkComponent } from './NamedLink';
import createNamedURL, { useNamedURL } from './createNamedURL';

export { createNamedURL, NamedLinkComponent, useNamedURL };
export default NamedLink;
